import React from 'react'
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import { C, SX, TYPE } from '../../merchants/shared/tokens'
import { saveBlob } from '../../freight-profitability/freightPnlUtils'
import { num } from '../constants'

/** Errors shown on screen; the full list downloads. */
const SHOWN_ERRORS = 10

const csvCell = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`

/**
 * Rejected rows of an upload check (PtlUploadCheck.errors), next to the action that fixes them: the first rows on
 * screen with row number, key and reason, and the whole list as a CSV.
 *
 * @param keyLabel  what the key column holds (Lane, Pincode)
 * @param fileName  name of the downloaded error list
 */
export default function UploadErrors({ errors, keyLabel = 'Lane', fileName }) {
  if (!errors?.length) return null
  const download = () => {
    const lines = [`Row,${keyLabel},Reason`, ...errors.map((r) => [r.row || 'File', r.key, r.reason].map(csvCell).join(','))]
    saveBlob(new Blob([lines.join('\n')], { type: 'text/csv' }), fileName)
  }
  return (
    <Box sx={{ ...SX.cardFlush, overflowX: 'auto', mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.75, py: 1.25, borderBottom: `1px solid ${C.line}`, bgcolor: C.dangerSoft }}>
        <Typography role='alert' sx={{ ...TYPE.rowLabel, color: C.danger, flex: 1 }}>
          {num(errors.length)} row{errors.length > 1 ? 's' : ''} with errors{errors.length > SHOWN_ERRORS ? ` (first ${SHOWN_ERRORS} shown)` : ''}
        </Typography>
        <Button size='small' onClick={download} sx={{ textTransform: 'none', fontWeight: 600, color: C.danger }}>Download error list</Button>
      </Box>
      <Table size='small' aria-label='Rows with errors'>
        <TableHead>
          <TableRow>
            {['Row', keyLabel, 'Reason'].map((h) => <TableCell key={h} sx={{ ...TYPE.eyebrow, fontSize: 10, color: C.inkFaint, borderColor: C.line }}>{h}</TableCell>)}
          </TableRow>
        </TableHead>
        <TableBody>
          {errors.slice(0, SHOWN_ERRORS).map((r, i) => (
            <TableRow key={`${r.row}-${i}`} sx={{ '& td': { borderColor: C.lineSoft, fontSize: 12.5 } }}>
              <TableCell sx={{ fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>{r.row || 'File'}</TableCell>
              <TableCell sx={{ fontFamily: 'JetBrains Mono, monospace', whiteSpace: 'nowrap' }}>{r.key || '—'}</TableCell>
              <TableCell sx={{ color: C.inkBody }}>{r.reason}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}
